import {
    useEffect,
    useState
} from 'react';
import {
    useLocation
} from 'react-router-dom';
import {
    Button,
    Divider,
    Image,
    Input,
    Modal,
    ModalContent,
    ModalHeader,
    ModalBody,
    Popover,
    PopoverTrigger,
    PopoverContent,
    Spacer,
    Switch,
    Textarea
} from "@nextui-org/react";
import Ajax from "../inc/js/Ajax";
import {
    HelmetWrapper,
    textToClipboard,
    HandleWebShare
} from "../inc/js/Helper"
import { MapView } from "../inc/js/MapView";
import {
    AlertTriangle6Red,
    ArrowUpRight8Blue,
    BlueMapPin8,
    Link6White,
    PhoneOutgoing,
    ShareIcon6White,
    Save_8_Blue,
    Send8Blue,
    Trophy8White
} from "../inc/images/svgs";
import swal from "sweetalert2";

export default function EventView({clientInformation}) {
    const hostName = window.location.hostname;
    const location = useLocation();
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    const [eventDetails, setEventDetails] = useState({});
    const [eventImage, setEventImage] = useState();
    const [editMode, setEditMode] = useState(false);
    const [host, setHost] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [qrCode, setQRCode] = useState(null);
    const [viewConfig, setViewConfig] = useState({});

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const code = queryParams.get("code") || localStorage.getItem("code");

        if (window.history.replaceState) {
            window.history.replaceState(null, null, window.location.pathname);
        }
        
        if (code) {
            localStorage.setItem('code', code);
            setQRCode(code);

            Ajax.request({
                url:"/JudgeAutos/getEventView",
                jsonData:{code:code},
                success:function(reply) {
                    setEventDetails(reply.data.eventDetails);
                    setViewConfig(reply.data.eventDetails.config ? JSON.parse(reply.data.eventDetails.config) : {});
                    setHost(reply.data.isHost);
                }
            })
        } else {
            swal.fire({
                title: "No code was given",
                text: "A valid code must be provided",
                icon: "error",
                didClose: () => {
                    document.location.href = "/"
                }
            })
        }
    }, []);

    const handleUploadImg = (file) => {
        if (!clientInformation?.userInformation?.loggedIn) {
            swal.fire({
                title: "Please log in",
                text: "You must be logged in to do that!",
                icon: "error"
            })

            return;
        }

        if (file) {
            Ajax.request({
                url:"/JudgeAutos/saveEventImage",
                method: "POST",
                rawData: {
                    file: file,
                    code: qrCode
                },
                success:function(reply) {
                    swal.fire({
                        title: `${reply.data}`,
                        text: `Image saved successfully`,
                        icon: "success",
                        timer: 3000,
                        showConfirmButton: false
                    }).then(() => (
                        window.location.reload()
                    ))
                }
            })
        } else {
            swal.fire({
                title: "No file selected",
                text: "Please select a jpg or png image",
                icon: "error"
            })
        }
        
    }

    const saveConfig = () => {
        Ajax.request({
            url:"/JudgeAutos/saveEventViewConfig",
            jsonData: {
                code: qrCode,
                viewConfig: JSON.stringify(viewConfig)
            },
            success:function(reply) {
                swal.fire({
                    title: `${reply.data}`,
                    text: `Event view updated`,
                    icon: "success",
                    timer: 3000,
                    showConfirmButton: false
                }).then(() => (
                    window.location.reload()
                ))
            }
        })
    }

    const handleGetDirections = (address) => {
        if (!address) return;

        const encoded = encodeURIComponent(address);

        if (isMobile) {
            window.location.href = `maps://?daddr=${encoded}`;
        } else {
            const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encoded}`;
            window.open(googleMapsUrl, "_blank");
        }
    };


    const updateViewConfig = (path, value) => {
        setViewConfig(prev => {
            if (!prev) return prev;

            let newConfig = { ...prev };
            let temp = newConfig;
            
            for (let i = 0; i < path.length - 1; i++) {
            const key = path[i];
            
            temp[key] = Array.isArray(temp[key]) ? [...temp[key]] : { ...temp[key] };
            temp = temp[key];
            }
            
            temp[path[path.length - 1]] = value;

            return newConfig;
        });
    }

    return (
        <>
            <HelmetWrapper
                title="View Car Show Event Details & Voting"
                description="View car show event details with JudgeAutos. Access location, date, contact info, and vote for your favorite cars via QR code or shared link."
                url="EventView"
            />

            <style>{`
                html, body {
                    overflow-x: hidden;
                    max-width: 100vw;
                }

                #root {
                    overflow-x: hidden;
                }
            `}</style>

            <div className="sm:w-1/3 text-center mx-auto">
                <div className="grid grid-cols-1 gap-4 m-4 p-5 ">
                    {eventDetails.eventName ? (
                        <>
                            <h1 className="text-5xl">{eventDetails.eventName}</h1>
                        </>
                    ) : (
                        <h1 className="text-5xl">Event</h1>
                    )}
                </div>
                <Divider />
                <Spacer y={1} />
                {host ? (
                    <>
                        <div className='flex justify-center gap-2'>
                            <p>Customize</p>
                            <Switch isSelected={editMode} onValueChange={setEditMode} color='primary'size='sm'/>
                        </div>
                        <Spacer y={2} />
                        <div className={`${!editMode && 'hidden'} flex justify-center gap-3`}>
                            <Button
                                color='primary'
                                onPress={() => setModalOpen(true)}
                            >
                                Options
                            </Button>
                            <Button
                                variant='light'
                                onPress={saveConfig}
                            >
                                <Save_8_Blue />
                            </Button>
                        </div>
                    </>
                ) : (
                    <></>
                )}
                <Spacer y={5} />
                <div className="grid grid-cols-2 gap-3">
                    <Button
                        variant='solid'
                        color='primary'
                        size='lg'
                        className={!viewConfig?.visibility?.share && "hidden"}
                        onPress={() => HandleWebShare(eventDetails.eventName, viewConfig?.text?.textarea || "", `https://${hostName}/EventView?code=${qrCode}`)}
                        endContent={<ShareIcon6White />}
                    >
                        Share
                    </Button>
                    <Popover
                        onOpenChange={(open) => {
                            if (open) {
                                textToClipboard(`https://${hostName}/EventView?code=${qrCode}`);
                            }
                        }}
                    >
                        <PopoverTrigger>
                            <Button
                                variant="solid"
                                color="primary"
                                size="lg"
                                className={viewConfig?.visibility?.copyURL ? "" : "hidden"}
                                endContent={<Link6White />}
                            >
                                Copy URL
                            </Button>
                        </PopoverTrigger>

                        <PopoverContent>
                            Link copied!
                        </PopoverContent>
                    </Popover>
                </div>
                <Spacer y={3} />
                <Button
                    variant="solid"
                    color="primary"
                    size="lg"
                    className={`${viewConfig?.visibility?.voting && eventDetails.voting ? "" : "hidden"} w-full`}
                    onPress={() => {window.open(`/PeoplesChoice?event=${eventDetails.eventName}&code=${qrCode}`, "_blank")}}
                    endContent={<Trophy8White />}
                >
                    People's Choice!
                </Button>
                <Spacer y={5} />
                {eventDetails?.eventImage && (
                    <Image
                        className={!viewConfig?.visibility?.image && "hidden"}
                        src={eventDetails.eventImage}
                    />
                )}
                <Spacer y={1} />
                <Input
                    label="Event Flyer"
                    className={!editMode ? "hidden" : ""}
                    classNames={{input: "text-[16px]"}}
                    type="file"
                    accept="image/png,image/jpeg"
                    onChange={(e) => setEventImage(e.target.files?.[0])}
                    endContent= {
                        <Button
                            variant='light'
                            onPress={() => handleUploadImg(eventImage)}
                        >
                            <Save_8_Blue />
                        </Button>
                    }
                />
                <Spacer y={5} />
                <div className="grid grid-cols-2 gap-3">
                    <Input
                        isReadOnly
                        key="eventDate"
                        id="eventDate"
                        label="Event Date"
                        value={eventDetails.eventDate}
                        size='lg'
                        variant="underlined"
                        className={!viewConfig?.visibility?.eventDate && "hidden"}
                        classNames={{input: "text-[16px]"}}
                    />
                    <Input
                        isReadOnly
                        key="rainoutDate"
                        id="eventDate"
                        label="Rainout Date"
                        value={eventDetails.rainoutDate}
                        size='lg'
                        variant="underlined"
                        className={!viewConfig?.visibility?.rainoutDate && "hidden"}
                        classNames={{input: "text-[16px]"}}
                    />
                </div>
                <Spacer y={3} />
                <Input
                    isReadOnly={!editMode}
                    key="website"
                    id="website"
                    label="Website"
                    value={viewConfig?.text?.website}
                    onChange={e => updateViewConfig(["text", "website"], e.target.value)}
                    size='lg'
                    variant="bordered"
                    className={!viewConfig?.visibility?.website && "hidden"}
                    classNames={{input: "text-[16px]"}}
                    endContent={
                        <Button
                            variant='light'
                            onPress={() => {window.open(viewConfig?.text?.website, "_blank")}}
                        >
                            <ArrowUpRight8Blue />
                        </Button>
                    }
                />
                <Spacer y={3} />
                <Input
                    isReadOnly={!editMode}
                    key="phone"
                    id="phone"
                    label="Contact phone"
                    value={viewConfig?.text?.phone}
                    onChange={e => updateViewConfig(["text", "phone"], e.target.value)}
                    size='lg'
                    variant="bordered"
                    type="tel"
                    className={!viewConfig?.visibility?.phone && "hidden"}
                    classNames={{input: "text-[16px]"}}
                    endContent={
                        <a href={`tel:${viewConfig?.text?.phone}`} style={{ textDecoration: 'none' }}>
                            <Button variant="light">
                                <PhoneOutgoing />
                            </Button>
                        </a>
                    }
                />
                <Spacer y={3} />
                <Input
                    isReadOnly={!editMode}
                    key="email"
                    id="email"
                    label="Contact Email"
                    value={viewConfig?.text?.email}
                    onChange={e => updateViewConfig(["text", "email"], e.target.value)}
                    size='lg'
                    variant="bordered"
                    className={!viewConfig?.visibility?.email && "hidden"}
                    classNames={{input: "text-[16px]"}}
                    endContent={
                        <Button
                            variant='light'
                            onPress={() => {window.location.href = `mailto:${viewConfig?.text?.email}`}}
                        >
                            <Send8Blue />
                        </Button>
                    }
                />
                <Spacer y={3} />
                {!editMode ? (
                    <p
                        className={`
                            w-full
                            min-h-[120px]
                            p-3
                            border
                            border-default-300
                            rounded-lg
                            bg-transparent
                            text-default-900
                            text-sm
                            text-left
                            leading-relaxed
                            whitespace-pre-wrap
                            ${!viewConfig?.visibility?.textarea && "hidden"}
                        `}
                    >
                        {viewConfig?.text?.textarea}
                    </p>
                ):(
                    <Textarea
                        isReadOnly={!editMode}
                        className={!viewConfig?.visibility?.textarea && "hidden"}
                        variant={!editMode ? 'bordered' : 'faded'}
                        classNames={{input: "text-[16px]"}}
                        value={viewConfig?.text?.textarea}
                        onChange={e => updateViewConfig(["text", "textarea"], e.target.value)}
                    />
                )}
                <Spacer y={5} />
                <Popover
                    onOpenChange={(open) => {
                        if (open) {
                            textToClipboard(eventDetails?.eventLocation);
                        }
                    }}
                >
                    <PopoverTrigger>
                        <Input
                            isReadOnly
                            key="eventLocation"
                            id="eventLocation"
                            label="Address"
                            value={
                                eventDetails?.eventLocation?.length > 30 && isMobile
                                ? eventDetails.eventLocation.substring(0, 30).trim() + '...'
                                : eventDetails?.eventLocation
                            }
                            size='lg'
                            variant="underlined"
                            className={!viewConfig?.visibility?.map && "hidden"}
                            classNames={{input: "text-[16px]"}}
                            endContent={
                                <Button
                                    variant='light'
                                    onPress={() => {
                                        handleGetDirections(eventDetails?.eventLocation)
                                    }}
                                >
                                    <BlueMapPin8 />
                                </Button>
                            }
                        />
                    </PopoverTrigger>
                    <PopoverContent>
                        Address copied!
                    </PopoverContent>
                </Popover>
                <Spacer y={3} />
                <MapView  address={viewConfig?.visibility?.map && eventDetails?.eventLocation}  />
            </div>
            <Modal
                isDismissable={false}
                isOpen={modalOpen}
                scrollBehavior="outside"
                onClose={() => {
                    setModalOpen(false);                          
                }}
                placement="center"
                className="w-11/12"
            >
                <ModalContent>
                    <ModalHeader className="flex justify-center items-center text-center text-3xl">
                        View Options
                    </ModalHeader>
                        <ModalBody>
                            <div>
                                <h3 className="font-semibold text-xl">Visibility</h3>
                                <Spacer y={2} />
                                <div className="grid grid-cols-2 gap-x-12 gap-y-2">
                                    {viewConfig?.visibility && Object.entries(viewConfig.visibility).map(([key, value]) => (
                                        <div key={key} className="flex items-center justify-between gap-2">
                                            {key === "voting" && value && !eventDetails.voting ? 
                                                <Popover isOpen={key === "voting" && value && !eventDetails.voting}>
                                                    <PopoverTrigger>
                                                        <Button
                                                            size="sm"
                                                            variant="light"
                                                        >
                                                            <AlertTriangle6Red />
                                                        </Button>
                                                    </PopoverTrigger>
                                                    <PopoverContent>
                                                        <p>
                                                            Voting disabled by default. Please create an <a href="/Forms?tab=Options" className="text-blue-500 underline">Option</a> with it enabled and attach it to your event.
                                                        </p>
                                                    </PopoverContent>
                                                </Popover> :
                                                <span className="capitalize text-lg">{key}</span>
                                            }
                                            <Switch
                                                size="sm"
                                                isSelected={value}
                                                onChange={() => updateViewConfig(["visibility", key], !value)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <Spacer y={3} />
                            <Button
                                color='primary'
                                className='text-xl'
                                variant='solid'
                                onPress={saveConfig}
                            >
                                Save
                            </Button>
                        </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
}